import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { SportBrand, UpsertSportBrand } from '@/models/sport-brand.model';

export const getPagedSportBrands = async (input: PaginationFilterRequest): Promise<PagedResponseModel<SportBrand>> => {
  return await getReq(createUrl("a/SportBrand/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getSportBrandsLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedSportBrands(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getSportBrand = async (id: number): Promise<BaseResponseModel<SportBrand>> => {
  return await getReq(createUrl(`a/SportBrand/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertSportBrand = async (input: UpsertSportBrand): Promise<BaseResponseModel<SportBrand>> => {
  return await postReq(createUrl("a/SportBrand/Upsert"),
    input
  ).then((res: any) => res.data);
};
